// extracted by mini-css-extract-plugin
module.exports = {"container":"GladlyBreadcrumbs_container__d1U7N","breadcrumbs":"GladlyBreadcrumbs_breadcrumbs__XfIq6"};